export default __webpack_public_path__ + "static/media/Banner-Sessoes.ddebcd7c.png";